/**
 * Doomsworn — the Powers of record
 *
 * A Power is a creditor with terms: a Domain (what it can do for you), a Tariff
 * (what it takes), and an Appetite (a standing agenda the world tick pursues
 * whether or not the party is looking). It is not a devil. It does not tempt,
 * gloat, or bargain. It states terms, and its terms are enforceable whether or
 * not anyone is persuaded.
 *
 * Only KETHREM is written. The Law-side Lords of the Ordinance are named in
 * `docs/worlds/long-indenture/WORLD.md` only by their sworn Houses — Corveth,
 * the Assize — and the Lords behind them are deliberately still unwritten. The
 * engine works fine with one Power on the books; adding more is world design,
 * not engineering, and it should be done at the table rather than here.
 */
/**
 * KETHREM, THE UNFINISHED — Chaos.
 *
 * The reason it is the reference Power: its Appetite generates plot without
 * anyone rolling anything. It is collecting completed things in order to
 * reopen them, so a finished treaty is an intolerable provocation — and the
 * Indenture is a treaty with an expiry date.
 */
export const KETHREM = {
    id: 'kethrem',
    name: 'Kethrem, the Unfinished',
    side: 'chaos',
    domain: 'becoming, dissolution, the moment before a thing settles',
    verbs: ['Unmake', 'Become', 'Open', 'Quicken'],
    tariff: 'It takes final forms. Your face at rest. The way you sign your name.',
    appetite: 'collecting completed things in order to reopen them — it regards a finished treaty as an intolerable provocation',
};
/** Every Power the engine knows about. */
export const DOOMSWORN_POWERS = [KETHREM];
export function getPower(id) {
    return DOOMSWORN_POWERS.find(p => p.id === id);
}
//# sourceMappingURL=powers.js.map